import React from 'react';
import { Link } from 'react-router-dom';

const TopOne = () => {
    return(
        <>
        {/*Header Top*/}
        <div className="header-top">
            <div className="default-container">
                <div className="clearfix">
                    {/*Top Left*/}
                    <div className="top-left">
                    <ul className="header-info-list">
                        <li><i className="icon fa fa-envelope" /><a href="mailto:support@example.com">support@example.com</a></li>
                        <li><i className="icon fa fa-map-marker" />621 Columbia Rd #38, Magnolia, AR, 71753</li>
                        <li><i className="icon fa fa-headphones" /><a href="tel:+1234567890">+123 456 7890</a></li>
                    </ul>
                    </div>
                    {/*Top Right*/}
                    <div className="top-right">
                    {/*Social Box*/}
                    <ul className="social-box">
                        <li><Link to="#"><i className="fa fa-facebook" /></Link></li>
                        <li><Link to="#"><i className="fa fa-linkedin" /></Link></li>
                        <li><Link to="#"><i className="fa fa-vimeo" /></Link></li>
                        <li><Link to="#"><i className="fa fa-pinterest" /></Link></li>
                        <li><Link to="#"><i className="fa fa-instagram" /></Link></li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default TopOne;